export const FETCH_CURRENT_INSTANCE = "FETCH_CURRENT_INSTANCE";
export const FETCH_CURRENT_INSTANCE_PENDING = "FETCH_CURRENT_INSTANCE_PENDING";
export const FETCH_CURRENT_INSTANCE_REJECTED = "FETCH_CURRENT_INSTANCE_REJECTED";
export const FETCH_CURRENT_INSTANCE_FULFILLED = "FETCH_CURRENT_INSTANCE_FULFILLED";
export const EDIT_INSTANCE = "EDIT_INSTANCE";
export const SET_ANSWER_ALTERNATIVE_COLLECTIONS = "SET_ANSWER_ALTERNATIVE_COLLECTIONS";